import { SelectInput } from '@frontend/basic-forms';
import React from 'react';
import { ActionMeta } from 'react-select';

import useTransactionStateSelect from './transaction-state-select.controller';

const ID = 'transaction-state-select';
export interface TransactionStateSelectProps {
    label?: string;
    className?: string;
    required: boolean;
    submitted: boolean;
    onChange: (newValue: { value: string; label: any }, actionMeta: ActionMeta<any>) => void;
    value?: string;
}

export const TransactionStateSelect = (props: TransactionStateSelectProps) => {
    const viewProps = useTransactionStateSelect();

    return (
        <SelectInput
            id={ID}
            className={props.className}
            label={props.label || 'Transaction state'}
            submitted={props.submitted}
            required={props.required}
            options={viewProps.options}
            value={props.value}
            onChange={(value, actionMeta) => props.onChange(value as { value: string; label: any }, actionMeta)}
        />
    );
};
